import React from "react";
import {} from "prop-types";
import { metaParser } from "../../../../common/helpers.js";
import Sorters from "../Sorters/Sorters.jsx";

const propTypes = {};

const SortSelected = ({ serverData }) => {
  const hasResults = serverData?.data?.pager?.total_results > 0;
  const hasSorters = serverData?.data?.sorters?.length > 0;
  const parsedFacets = metaParser(serverData?.data);

  // console.log("serverData.data: ", serverData?.data);

  return serverData.isLoading ? null : (
    <>
      {hasResults && hasSorters && (
        <div className="search__sorters">
          <Sorters sorters={serverData.data.sorters} />
        </div>
      )}
    </>
  );
};

SortSelected.propTypes = propTypes;
export default SortSelected;
